/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaPictureIcon20Solid = forwardRef('MediaPictureIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 6a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V6Zm6.321.531a1.825 1.825 0 1 1-3.65 0 1.825 1.825 0 0 1 3.65 0Zm2.913 4.163a.73.73 0 0 1 1.032 0l2.332 2.333a.834.834 0 0 0 1.179-1.179l-2.333-2.332a2.396 2.396 0 0 0-3.388 0L4.91 14.66a.833.833 0 0 0 1.178 1.178l5.145-5.145Z" })));
});
